import { ref, onMounted, onUpdated } from 'vue';

// Lodash-Funktionen
import assign from 'lodash/assign';
import filter from 'lodash/filter';
import merge from 'lodash/merge';
import intersection from 'lodash/intersection';
import isNil from 'lodash/isNil';

import { getMenu, getMenus, storeMenu, deleteMenu, menuCopy, checkErrorsMenu, exportMenu } from '@/api/menus';
import routes from '@/routes';

export default function useMenus(currentRoute = null) {
  const links = ref([]);
  const menu = ref({});
  const menus = ref([]);
  const pagination = ref({});

  const buildLinks = () => {
    links.value = filter(routes, { name: 'configuration' })[0].children;
  };

  const menuDataHandler = (data) => {
    // Letzte Route in der Datenbank speichern
    menu.value.attributes.recent_step = currentRoute.name;
    merge(menu.value.attributes, data);

    saveMenu();
  };

  const saveMenu = async () => {
    const storedMenu = await storeMenu(menu.value);
    // Wenn die API einen Error-Object zurückliefert, soll errors in menu gemergt werden
    if (storedMenu.errors) {
      assign(menu.value, storedMenu);
    } else {
      menu.value = storedMenu;
    }
  };

  const fetchMenu = async (menuid) => {
    const fetchedMenu = await getMenu(menuid);
    menu.value = fetchedMenu.data;
  };

  const copyMenu = async (menuId) => {
    await menuCopy(menuId);
    window.location.reload();
  };

  const removeMenu = async (menuId) => {
    await deleteMenu(menuId);
    window.location.reload();
  };

  const prepareExportMenu = async (menuId) => {
    const response = await exportMenu(menuId);

    return await response.json();
  };

  const fetchMenus = async (pageSize) => {
    const nextLink = {
      link: pagination.value?.next ? pagination.value.next : null,
    };
    const request = merge({}, { pageSize }, nextLink);
    const fetchedMenus = await getMenus(request);
    // merge local menus with axios response (pagination)
    menus.value = [...menus.value, ...fetchedMenus.data];
    pagination.value = fetchedMenus.pagination;
  };

  const disableMissedSteps = () => {
    const { attributes } = menu.value;
    if (!attributes) {
      return false;
    }
    const filledAttributes = filledKeysDeep(attributes);
    links.value.forEach((link, i) => {
      // Sind bei der letzten Seite
      if (i === links.value.length - 1) {
        return;
      }

      if (links.value[i].meta.disabled) {
        links.value[i + 1].meta.disabled = true;
        return;
      }

      const requiredAttributes = link.meta.requiredAttributes;
      const equalAttributes = intersection(filledAttributes, requiredAttributes);

      if (equalAttributes.length === requiredAttributes.length) {
        links.value[i + 1].meta.disabled = false;
      } else {
        links.value[i + 1].meta.disabled = true;
      }
    });
  };

  const filledKeysDeep = (obj) => {
    return Object.keys(obj)
      .filter((key) => obj[key] instanceof Object)
      .map((key) => filledKeysDeep(obj[key]).map((k) => `${key}.${k}`))
      .reduce(
        (x, y) => x.concat(y),
        Object.keys(obj).filter((i) => !isNil(obj[i]))
      );
  };

  onUpdated(() => {
    disableMissedSteps();
  });

  onMounted(() => {
    buildLinks();
  });

  return {
    fetchMenu,
    fetchMenus,
    links,
    menu,
    menuDataHandler,
    menus,
    pagination,
    removeMenu,
    menuCopy,
    copyMenu,
    checkErrorsMenu,
    prepareExportMenu,
  };
}
